import { LinkFragment, MediaBlockFragment } from '@/lib/fragments'

import { graphql } from '@/lib/query'

const SectionTextFragment = graphql(
  /* GraphQL */ `
    fragment SectionTextFragment on SectionTextRecord @_unmask {
      id
      _modelApiKey
      __typename
      title
      titleSmall
      titleRight
      content
      buttons {
        ...LinkFragment
      }
      linkList {
        ...LinkFragment
      }
      media {
        ...MediaBlockFragment
      }
      background
    }
  `,
  [LinkFragment, MediaBlockFragment]
)

export default SectionTextFragment
